import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const TIMESPANS = ['1year', '6months', '1month', '1week', '1day'];

export default function TimespanSelector({ onChange = () => null }) {
  const { t } = useTranslation();
  const onChangeRef = useRef(onChange, []);
  const [value, setValue] = useState('1day');

  useEffect(() => {
    onChangeRef.current(value);
  }, [onChangeRef, value]);

  return (
    <div className="inline-flex bg-gray-100 rounded-lg p-1 gap-0.5">
      {TIMESPANS.map(ts => (
        <button
          key={ts}
          onClick={() => setValue(ts)}
          className={`whitespace-nowrap px-3 py-1.5 rounded-md text-xs sm:text-sm font-medium transition-all duration-200 flex-1 ${
            value === ts
              ? 'bg-primary text-black shadow-sm'
              : 'text-neutral hover:text-black'
          }`}
        >
          {t(`timespan.${ts}`)}
        </button>
      ))}
    </div>
  );
}
